import { leagueFetch } from '@leagueplatform/league-fetch';
import { useQuery } from '@tanstack/react-query';
import { getCaregiverImpersonationState } from '@leagueplatform/caregiver';

export const CAREGIVER_STATUS_QUERY_KEY = 'caregiver-status';

const getCaregiverStatus = async (): Promise<boolean> => {
  const response = await leagueFetch('/v1/caregiver-status');

  if (!response.ok) {
    throw new Error(`caregiver-status error: ${response.status}`);
  }

  const json = await response.json();
  return json.data.attributes.isCaregiver as boolean;
};

export const useGetCaregiverStatus = () => {
  const query = useQuery({
    queryKey: [CAREGIVER_STATUS_QUERY_KEY],
    queryFn: getCaregiverStatus,
  });

  const { impersonateeLeagueUserId } = getCaregiverImpersonationState();
  const isImpersonating = Boolean(impersonateeLeagueUserId);

  return {
    ...query,
    data: query.data && !isImpersonating,
    isImpersonationStarted: isImpersonating,
  };
};
